import React from "react";
import "../Product/Intro.css";
import { useLanguage } from "../LanguageContext";
import "./Whoweare.css";
const AboutWhoweare = () => {
  const { language } = useLanguage();

  return (
    <>
      <div className="hardware-container">
        <div className="content">
          <h2 className="heading">Who We Are</h2>
          <p className="description">
            {language === "en" ? (
              <>
                Since our founding in 2013,<strong> Proscope </strong> has grown
                into a leading IT solution provider and system integrator based
                in Thailand. Our mission is simple yet powerful:
                <strong>
                  {" "}
                  to deliver the right technology, in the right way, to help
                  organizations grow securely, efficiently, and intelligently.
                </strong>
                <br />
                <br />
              </>
            ) : (
              <>
                {" "}
                นับตั้งแต่ก่อตั้งในปี 2013 <strong> Proscope </strong>{" "}
                ได้เติบโตเป็นผู้ให้บริการโซลูชันด้านไอที
                และระบบอินทิเกรเตอร์ชั้นนำในประเทศไทย
                เรามุ่งมั่นส่งมอบเทคโนโลยีที่เหมาะสม ในวิธีที่เหมาะสม
                เพื่อช่วยให้องค์กรเติบโตได้อย่างปลอดภัย มีประสิทธิภาพ และชาญฉลาด
                <br />
                <br />
              </>
            )}
          </p>
          <p className="description">
            {language === "en" ? (
              <>
                We partner with top global vendors, as well as emerging
                technology providers, to offer comprehensive IT services —
                ranging from infrastructure and networking to cloud,
                cybersecurity, ERP, and software development. But what truly
                defines Proscope is not just the technologies we implement —
                it's the way we think, collaborate, and commit to our clients.
                <br />
                <br />
              </>
            ) : (
              <>
                เราทำงานร่วมกับพันธมิตรระดับโลกและผู้พัฒนาเทคโนโลยีหน้าใหม่
                เพื่อให้บริการอย่างครบวงจร ตั้งแต่โครงสร้างพื้นฐาน ระบบเครือข่าย
                คลาวด์ ซิเคียวริตี้<strong> ERP </strong>ไปจนถึงการพัฒนา
                <strong> Software </strong>
                ที่ตอบโจทย์การใช้งานจริง แต่สิ่งที่ทำให้
                <strong> Proscope </strong>แตกต่าง
                ไม่ใช่แค่เทคโนโลยีที่เรานำเสนอ — แต่คือวิธีคิด วิธีทำงาน
                และความมุ่งมั่นที่มีต่อทุกองค์กรที่เราร่วมมือด้วย
                <br />
                <br />
              </>
            )}
          </p>
          <p className="description">
            {language === "en" ? (
              <>
                <strong> Our Philosophy </strong>
              </>
            ) : (
              <>
                <strong>ปรัชญาในการทำงานของเรา</strong>
              </>
            )}
          </p>
          <p className="description">
            {language === "en" ? (
              <>
                We believe that{" "}
                <strong> technology is a tool, not a goal. </strong>The true
                value lies in how it supports people, enhances workflows, and
                unlocks opportunities. At Proscope, we follow a consultative,
                client-first approach. We ask, listen, and understand before we
                build.
                <br />
                <br />
              </>
            ) : (
              <>
                เราเชื่อว่า{" "}
                <strong> เทคโนโลยีไม่ใช่เป้าหมาย แต่มันคือเครื่องมือ </strong>
                ที่ช่วยส่งเสริมผู้คน ยกระดับการทำงาน และเปิดประตูสู่โอกาสใหม่ๆ
                <strong> Proscope </strong> ยึดหลัก "ลูกค้าเป็นศูนย์กลาง"
                ฟังอย่างตั้งใจ วิเคราะห์อย่างเข้าใจ
                แล้วจึงออกแบบสิ่งที่ตอบโจทย์จริง
                <br />
                <br />
              </>
            )}
          </p>
          <p className="description">
            {language === "en" ? (
              <>
                "We listen. We design. We deliver — with integrity and
                expertise.”
                <br />
                <br />
              </>
            ) : (
              <>
                {" "}
                “เรารับฟัง เราออกแบบ และเราส่งมอบ —
                ด้วยความซื่อสัตย์และความเชี่ยวชาญ”
                <br />
                <br />
              </>
            )}
          </p>
          <p className="description">
            {language === "en" ? (
              <>
                This philosophy drives every project we undertake. It ensures
                that each solution is aligned with real business needs, not
                trends or hype. Our clients trust us not just for our technical
                capabilities, but for our strategic thinking and long-term
                perspective.
              </>
            ) : (
              <>
                {" "}
                หลักคิดนี้คือน้ำหนักที่อยู่เบื้องหลังทุกโปรเจกต์
                เพื่อให้แน่ใจว่า ทุกโซลูชันที่เราส่งมอบ
                จะตอบสนองความต้องการทางธุรกิจอย่างแท้จริง ไม่ใช่แค่ตามกระแส
              </>
            )}
          </p>

          <div className="horizontal-text-container">
            <p>About Us</p>
            <p>/</p>
            <p>Who We Are</p>
          </div>
        </div>
        
      </div>
    </>
  );
};

export default AboutWhoweare;
